import React from 'react';
import { TimeoutLogic } from "../utils/TimeoutLogic";
// import { useHistory } from "react-router-dom";
// import { useDispatch } from 'react-redux';

// import { getTempDetail } from '../store/actions/CommonAction';

  const  HtmlPage =(props) => {

    // const {state,value} = props.location
    const {formatVal} = props
    // const [val,setVal] = useState(state)

    // const history = useHistory()
    // const dispatch = useDispatch();

    // function trim () {
    //   setVal(state.replaceAll("\n", ""))
    // }

    // const getdata = async () => {
    //   if(value && value.templateId){
    //     await dispatch(getTempDetail(value.templateId))
    //   }
    // }

    // useEffect(() => {
    //   console.log("val is ",value)
    //   trim()
    //   getdata()
    // }, [val]);



    function createMarkup() {
      return {__html: formatVal};
    }


    // const close = async () => {
    //   // history.push("/templatelist")
    // }


    return (
      <>
         {/* <div className="col-md-12 text-right"> */}
            {/* <button   className="btn btn-outline-primary btn-sm  m-2 text-center" onClick={close}>Close</button> */}
            {/* <MaterialButton variant="outlined" color="primary"className='mt-3 mb-3'  onClick={close}>Close</MaterialButton> */}

          {/* </div> */}
          <div className="">
           {formatVal && <div dangerouslySetInnerHTML={createMarkup()} />}
          </div>

      </>
    )
    
  }


  export default HtmlPage;

  